import Controller from './controller'
import Visible from './visible_controller'
import { scrollToPosition } from '../utilities'

export default class Filter extends Controller {
  static targets = ['form', 'results']

  static values = {
    urlPattern: String,
  }

  initialize() {
    this.setQueryString()
  }

  setQueryString(callback) {
    const params = new URLSearchParams(new FormData(this.formTarget))

    const deleteKeys = []
    for (const [key, value] of params) {
      if (!value) {
        deleteKeys.push(key)
      }
    }
    for (const key of deleteKeys) {
      params.delete(key)
    }

    params.sort()
    this.params = params

    let queryString = params.toString()
    if (queryString !== '') {
      queryString = `?${queryString}`
    }

    if (queryString !== this.queryString) {
      this.queryString = queryString

      if (callback) {
        callback()
      }
    }
  }

  change() {
    this.setQueryString(() => {
      this.fetchResults()
    })
  }

  paginate(ev) {
    const link = ev.target.closest('a')

    if (link && link.href) {
      ev.preventDefault()

      // Get page number from link href, where format is e.g. path/to/page/3
      const segments = link.pathname.split('/')
      const page = Number(segments[segments.length - 1]) || 1
      this.fetchResults({ page })
    }
  }

  async fetchResults({ page = 1 } = {}) {
    this.scrollToTop()

    this.resultsTarget.classList.add('is-loading')

    const pageSegment = page > 1 ? `/page/${page}` : ''

    let historyUrl = this.data.get('base-url')

    if (this.urlPatternValue === 'tags') {
      historyUrl += this.urlPatternTags(pageSegment)
    } else {
      historyUrl += pageSegment + this.queryString
    }

    window.history.replaceState(null, '', historyUrl)

    const requestUrl = this.data.get('results-url') + pageSegment + this.queryString
    const response = await fetch(requestUrl)

    if (response.ok) {
      const html = await response.text()
      this.resultsTarget.innerHTML = html
    }

    Visible.observeVisibleItems(this.resultsTarget, this.application)
    this.resultsTarget.classList.remove('is-loading')
  }

  scrollToTop() {
    scrollToPosition({
      top: window.scrollY + this.element.getBoundingClientRect().top - 20,
    })
  }

  // Used for Insights tag filtering, to keep pretty URL matching config/routes.php
  urlPatternTags(pageSegment) {
    const tagSlugs = []

    for (const [, value] of this.params.entries()) {
      tagSlugs.push(value)
    }

    return (tagSlugs.length ? `/tag/${tagSlugs.join('/')}` : '') + pageSegment
  }
}
